// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetInspectionDataPointNotesListQuery,
    BaseResponseListInspectionDataPointNoteFoundResponse,
} from '../../types';

/**
 * 质检结果批注列表
 *
 * @export
 * @tags 质检结果批注
 * @link [GET] /inspectionDataPointNotes/list
 */
export function getInspectionDataPointNotesList(
    options: ApiOptions<never, GetInspectionDataPointNotesListQuery> & {
        params: GetInspectionDataPointNotesListQuery;
    }
): Promise<BaseResponseListInspectionDataPointNoteFoundResponse> {
    return request<never, never, GetInspectionDataPointNotesListQuery>(
        '/inspectionDataPointNotes/list',
        { ...options, method: 'get', __$requestCalleeName: 'getInspectionDataPointNotesList' }
    );
}

export const meta = [
    { tags: ['质检结果批注'], path: '/inspectionDataPointNotes/list', method: 'get' },
];
